// @flow
import { all } from 'redux-saga/effects';
import layoutSaga from './layout/saga';
import dashboardSaga from './dashboard/saga';

export default function* rootSaga() {
  yield all([layoutSaga(), dashboardSaga()]);
}
